/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponse interface.
 */
export function instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponse(value) {
    if (!('AccountId' in value) || value['AccountId'] === undefined)
        return false;
    if (!('Token' in value) || value['Token'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponseFromJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponseFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'AccountId': json['AccountId'],
        'Token': json['Token'],
    };
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponseToJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponseToJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'AccountId': value['AccountId'],
        'Token': value['Token'],
    };
}
//# sourceMappingURL=FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponse.js.map